import { TAGS_ROUTES } from '../../constants/_routes'
import tagsTypes from '../../constants/tagsTypes'
import { axios } from '../../services'

// import { try_force_logoff } from '../auth'

const create_tag_request = () => {
  return {
    type: tagsTypes.create.request
  }
}

const create_tag_success = (response) => {
  return {
    type: tagsTypes.create.success,
    payload: response.data
  }
}

const create_tag_failure = (messages) => {
  return {
    type: tagsTypes.create.failure,
    payload: messages
  }
}

const create_tag = (values) => {
  return function (dispatch) {
    // Before Request
    dispatch(create_tag_request())

    // Request
    axios.post(
      TAGS_ROUTES.create,
      values
    ).then( response => {
      // success
      dispatch( create_tag_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error creating tag."]
      }
      // dispatch( try_force_logoff(error.response) )
      dispatch( create_tag_failure(errors))
    })
  }

}

export {
  create_tag
}



// WEBPACK FOOTER //
// ./src/js/actions/tags/create.js